var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Observer from "zen-observable";
import ObserveWithPriority from "@irati/auth/helpers/auth/ObserveWithPriority";
import InternalAuth from "@irati/auth-internal/streams/auth";
import AuthedStream from "@irati/auth/streams/auth";
import UnauthedStream from "@irati/auth/streams/unauthed";
import GlobalStream from "@irati/auth/streams/global";
import { PLATFORM } from "../../platform";
import platform from "./platform";
var MixpanelCommon = /** @class */ (function () {
    function MixpanelCommon() {
        var _this = this;
        this.observers = [];
        new ObserveWithPriority({ streams: [AuthedStream, UnauthedStream, InternalAuth, GlobalStream], key: "branding" })
            .subscribe(function (data) {
            _this.user = data.user;
            _this.business = data.business;
            _this.observers.forEach(function (observer) {
                observer.next({ user: _this.user, business: _this.business });
            });
        });
    }
    Object.defineProperty(MixpanelCommon.prototype, "stream", {
        get: function () {
            var _this = this;
            return new Observer(function (observer) {
                _this.observers.push(observer);
                return function () {
                    _this.observers = _this.observers.filter(function (t) { return t !== observer; });
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    MixpanelCommon.prototype.getDefaultAttributes = function () {
        var _a, _b, _c, _d, _e, _f;
        return {
            user_id: (_a = this.user) === null || _a === void 0 ? void 0 : _a.uuid,
            tenant_locale: (_b = this.user) === null || _b === void 0 ? void 0 : _b.locale,
            tenant_id: (_c = this.user) === null || _c === void 0 ? void 0 : _c.businessId,
            tenant_grouping: (_d = this.business) === null || _d === void 0 ? void 0 : _d.groupId,
            tenant_subdomain: (_e = this.business) === null || _e === void 0 ? void 0 : _e.subdomain,
            tenant_public_name: (_f = this.business) === null || _f === void 0 ? void 0 : _f.businessName,
            perkbox_platform: PLATFORM
        };
    };
    MixpanelCommon.prototype.trackEvent = function (name, dataAttributes) {
        var eventDefaultAttributes = this.getDefaultAttributes();
        return platform.trackEvent(name, __assign(__assign({}, eventDefaultAttributes), dataAttributes));
    };
    MixpanelCommon.prototype.setup = function (env) {
        return platform.setup(env);
    };
    return MixpanelCommon;
}());
var mixpanel = new MixpanelCommon();
export default mixpanel;
var isLoggedIn = false;
mixpanel.stream.subscribe(function (data) {
    if (data.user && !isLoggedIn) {
        isLoggedIn = true;
        platform.handleLogin(mixpanel.getDefaultAttributes());
    }
    else if (!data.user && isLoggedIn) {
        isLoggedIn = false;
        platform.handleLogout();
    }
});
